(function () {
  var STORAGE_KEY = 'a11yWidgetState';
  var FONT_STEP = 15; // percent
  var MIN_FONT = 80;
  var MAX_FONT = 160;
 
  function getState() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : { fontScale: 100, classes: [] };
    } catch (e) {
      return { fontScale: 100, classes: [] };
    }
  }
 
  function saveState(state) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
  }
 
  var baseFontSizePx = null;
 
  function getBaseFontSizePx() {
    if (baseFontSizePx === null) {
      // שומר את גודל הטקסט האמיתי של התבנית *לפני* כל שינוי שלנו
      baseFontSizePx = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
    }
    return baseFontSizePx;
  }
 
  function applyState(state) {
    if (state.fontScale === 100) {
      // אין שינוי - משאירים לתבנית לשלוט בגודל הטקסט שלה כרגיל
      document.documentElement.style.fontSize = '';
    } else {
      var basePx = getBaseFontSizePx();
      document.documentElement.style.fontSize = (basePx * state.fontScale / 100) + 'px';
    }
 
    ['a11y-high-contrast', 'a11y-underline-links', 'a11y-readable-font', 'a11y-stop-animations'].forEach(function (cls) {
      document.documentElement.classList.remove(cls);
    });
    state.classes.forEach(function (cls) {
      document.documentElement.classList.add(cls);
    });
 
    document.querySelectorAll('[data-a11y-toggle-class]').forEach(function (btn) {
      var cls = btn.getAttribute('data-a11y-toggle-class');
      btn.setAttribute('aria-pressed', state.classes.indexOf(cls) !== -1 ? 'true' : 'false');
    });
  }
 
  function init() {
    var widget = document.querySelector('[data-a11y-widget]');
    if (!widget) return;
 
    var toggleBtn = widget.querySelector('[data-a11y-toggle]');
    var closeBtn = widget.querySelector('[data-a11y-close]');
    var panel = widget.querySelector('[data-a11y-panel]');
    var state = getState();
 
    applyState(state);
 
    toggleBtn.addEventListener('click', function () {
      panel.hidden = !panel.hidden;
    });
    closeBtn.addEventListener('click', function () {
      panel.hidden = true;
    });
 
    document.addEventListener('click', function (e) {
      if (!widget.contains(e.target)) {
        panel.hidden = true;
      }
    });
 
    widget.querySelectorAll('[data-a11y-action]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = btn.getAttribute('data-a11y-action');
        if (action === 'font-increase') {
          state.fontScale = Math.min(MAX_FONT, state.fontScale + FONT_STEP);
        } else if (action === 'font-decrease') {
          state.fontScale = Math.max(MIN_FONT, state.fontScale - FONT_STEP);
        } else if (action === 'font-reset') {
          state.fontScale = 100;
        }
        saveState(state);
        applyState(state);
      });
    });
 
    widget.querySelectorAll('[data-a11y-toggle-class]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cls = btn.getAttribute('data-a11y-toggle-class');
        var idx = state.classes.indexOf(cls);
        if (idx === -1) {
          state.classes.push(cls);
        } else {
          state.classes.splice(idx, 1);
        }
        saveState(state);
        applyState(state);
      });
    });
 
    var resetBtn = widget.querySelector('[data-a11y-reset]');
    resetBtn.addEventListener('click', function () {
      state = { fontScale: 100, classes: [] };
      saveState(state);
      applyState(state);
    });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
 